import { render, staticRenderFns } from "./InscriptionOrder.vue?vue&type=template&id=28609e10&"
import script from "./InscriptionOrder.vue?vue&type=script&lang=js&"
export * from "./InscriptionOrder.vue?vue&type=script&lang=js&"
import style0 from "./InscriptionOrder.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports